export default __webpack_public_path__ + "static/hype-crafter-663b4c54c0b63bac98dd8b7267218e76.gif";